const buildModularBannersFromAd = (bannersAds, key) => {
  const modularBanners = []

  const ad = bannersAds[0]

  if (!ad) return modularBanners

  modularBanners.push({
    id: ad.ad_id,
    alt: 'Banner Patrocinado',
    title: 'Banner Patrocinado',
    type: 'banner',
    url: ad.destination_url,
    moduleUrl: ad.destination_url,
    schedule: {},
    pictures: {
      [key]: {
        title: 'Banner Patrocinado',
        alt: 'Banner Patrocinado',
        url: ad.media_url,
        image_size: {
          width: 728,
          height: 90
        },
        type: 'banner'
      }
    },
    retailMedia: {
      clickUrl: ad.click_url,
      impressionUrl: ad.impression_url,
      viewUrl: ad.view_url
    }
  })

  return modularBanners
}

export default buildModularBannersFromAd
